<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <b-row class="mb-4">
      <div class="w-full">
        <router-link :to="back" class="float-right">
          <b-button variant="primary" class="border-primary">{{$t('Back')}}</b-button>
        </router-link>
      </div>
    </b-row>
    <b-row>
      <div v-if="data.user_details" class="vx-col w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
      <b-card>
          <div>
            <!-- Open Tickets Heading -->
              <h4 class="heading pl-0">{{$t('UserDetails')}}</h4>
              <div class="export-table">
                <div class="vx-col">
                  <b-row class="image">
                    <div class="pointer-events-none w-1/2 Aligner-item">
                      <div class="pl-3">
                        <b-avatar
                          class="user-profile-img"
                          :src="(data.user_details.profile_image) ? data.user_details.profile_image:profile_image"
                          size="60px"
                        />
                      </div>
                    </div>
                    <div class="w-1/2 Aligner-item pl-5">
                      <strong>{{data.user_details.first_name}}{{" "+data.user_details.last_name}}</strong>
                    </div>
                  </b-row>
                    <b-row class="mt-4">
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="5">
                      <td class="font-semibold">{{$t('Email')}}</td>
                    </b-col>
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="7">
                      <td>{{data.user_details.email}}</td>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="5">
                      <td class="font-semibold">{{$t('ContactNumber')}}</td>
                    </b-col>
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="7">
                      <td>{{data.user_details.contact_number ? data.user_details.contact_number : 'NA'}}</td>
                    </b-col>
                  </b-row>
                </div>
              </div>
          </div>
      </b-card>
      </div>
      <div v-if="role=='super_admin' && data.company" class="vx-col w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
     <b-card>
       <div>
         <!-- Open Tickets Heading -->
              <h4 class="heading pl-0">{{$t('CompanyDetails')}}</h4>
              <div class="export-table">
                <div class="vx-col">
                  <b-row class="image">
                    <div class="pointer-events-none w-1/2 Aligner-item">
                      <div class="pl-3">
                        <b-avatar
                          class="user-profile-img"
                          :src="(data.company.profile_image) ? data.company.profile_image:profile_image"
                          size="60px"
                        />
                      </div>
                    </div>
                    <div class="w-1/2 Aligner-item pl-5">
                      <strong>{{data.company.company_name}}</strong>
                    </div>
                  </b-row>
                  <b-row class="mt-4">
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="5">
                      <td class="font-semibold">{{$t('Email')}}</td>
                    </b-col>
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="7">
                      <td>{{data.company.email}}</td>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="5">
                      <td class="font-semibold">{{$t('ContactNumber')}}</td>
                    </b-col>
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="7">
                      <td>{{data.company.contact_number}}</td>
                    </b-col>
                  </b-row>
                </div>
              </div>
       </div>
     </b-card>
      </div>
      <div v-if="data.department_details" class="vx-col w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 " :class="role == 'super_admin' ? 'mb-base' : ''">
        <b-card>
          <div>
            <!-- Open Tickets Heading -->
              <h4 class="heading pl-0">{{$t('DepartmentDetails')}}</h4>
              <div class="export-table">
                <div class="vx-col">
                    <b-row class="mt-4">
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="5">
                      <td class="font-semibold">{{$t('DepartmentName')}}</td>
                    </b-col>
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="7">
                      <td>{{data.department_details.department_name}}</td>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="5">
                      <td class="font-semibold">{{$t('Description')}}</td>
                    </b-col>
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="7">
                      <td>{{data.department_details.description}}</td>
                    </b-col>
                  </b-row>
                </div>
              </div>
          </div>
        </b-card>
      </div>
      <div v-if="data.staff_details" class="vx-col w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 " :class="role != 'super_admin' ? 'mb-base' : ''">
      <b-card>
              <div>
        <!-- Open Tickets Heading -->
              <h4 class="heading pl-0">{{$t('StaffDetails')}}</h4>
              <div class="export-table">
                <div class="b-col">
                  <b-row class="image">
                    <div class="pointer-events-none Aligner-item w-1/2">
                      <div class="pl-3">
                        <b-avatar
                          class="user-profile-img"
                          :src="(data.staff_details.profile_image) ? data.staff_details.profile_image:profile_image"
                          size="60px"
                        />
                      </div>
                    </div>
                    <div class="w-1/2 Aligner-item pl-5">
                      <strong>{{data.staff_details.first_name}}{{" "+data.staff_details.last_name}}</strong>
                    </div>
                  </b-row>

                    <b-row class="mt-4">
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="5">
                      <td class="font-semibold">{{$t('Email')}}</td>
                    </b-col>
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="7">
                      <td>{{data.staff_details.email}}</td>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="5">
                      <td class="font-semibold">{{$t('ContactNumber')}}</td>
                    </b-col>
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="7">
                      <td>{{data.staff_details.contact_number}}</td>
                    </b-col>
                  </b-row>
                </div>
              </div>
      </div>
      </b-card>

      </div>
      <div class="vx-colw-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 " :class="role == 'super_admin' ? 'mb-base' : ''">
      <b-card>
        <div>
          <!-- Open Tickets Heading -->
              <h4 class="heading pl-0">{{$t('PaymentDetails')}}</h4>
              <div class="export-table">
                <div class="vx-col">
                  <b-row class="mt-3">
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="5">
                      <td class="font-semibold">{{$t('PaymentId')}}</td>
                    </b-col>
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="7">
                      <td>{{data.payment_intent_id}}</td>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="5">
                      <td class="font-semibold">{{$t('PaymentStatus')}}</td>
                    </b-col>
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="7">
                      <td>{{( data.payment_status == '1') ? $t('Paid') : $t('NotPaid')}}</td>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="5">
                      <td class="font-semibold">{{$t('PaymentDate')}}</td>
                    </b-col>
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="7">
                      <td>{{data.payment_date}}</td>
                    </b-col>
                  </b-row>
                  <b-row v-if="data.department_details" class="mt-3">
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="5">
                      <td class="font-semibold">{{$t('Amount')}}</td>
                    </b-col>
                    <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="7">
                      <td>{{data.department_details.amount}}{{" "+data.department_details.currency}}</td>
                    </b-col>
                  </b-row>
                </div>
              </div>
        </div>
      </b-card>
      </div>
    </b-row>
  </div>
</template>

<script>
import vSelect from "vue-select";
import moment from "moment";

export default {
  props: {
    title: String,
    path: String,
    role: String,
    data: [Object, Array],
    back: String,
  },
  components: {
    vSelect,
  },
  data() {
    return {
      staffs: [],
      profile_image: require("@/assets/images/portrait/small/avatar-s-271.png"),
    };
  },
};
</script>

<style lang="stylus" scope>
.heading {
  padding: 10px;
}

.add {
  position: absolute;
  margin-top: 10px;
}

.vs-row {
  padding: 10px;
}

.mb-base {
  padding-right: 20px;
}

.image {
  display: flex;
  align-items: center;
  justify-content: center;
}

td {
  word-break: break-all;
}

.Aligner-item {
  max-width: 50%;
}
</style>